import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';

class UploadFatturePassiveModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack'
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService
  ) {
    $scope.updateInProgress = true;
    $scope.updateWithError = false;

    if ($scope.$parent.$resolve.admin) {
      ArchiSmallServices.uploadFatturePassiveAdmin($scope.$parent.$resolve.user, $scope.$parent.$resolve.dati)
        .then((res) => {
          $timeout(() => {
            $scope.updateInProgress = false;
            $scope.result = JSON.parse(JSON.stringify(res));
            $modalStack.getTop().value.keyboard = true;
            $modalStack.getTop().value.backdrop = true;
          }, 2000);
        }).catch((error) => {
        console.log(error);
        $rootScope.alert('error', error.data.message);
        $scope.cancel();
      });
    } else {
      ArchiSmallServices.uploadFatturePassive($scope.$parent.$resolve.user, $scope.$parent.$resolve.dati)
        .then((res) => {
          $timeout(() => {
            $scope.updateInProgress = false;
            $scope.result = JSON.parse(JSON.stringify(res));
            $modalStack.getTop().value.keyboard = true;
            $modalStack.getTop().value.backdrop = true;
          }, 2000);
        }).catch((error) => {
        console.log(error);
        $rootScope.alert('error', error.data.message);
        $scope.cancel();
      });
    }


    $scope.ok = () => {
      this.close();
    };
    $scope.cancel = () => {
      this.dismiss({$value: 'cancel'});
    };
  }
}

export const UploadFatturePassiveModalComponent: ng.IComponentOptions = {
  template: require('./upload-fatture-passive-modal.html'),
  controller: UploadFatturePassiveModalController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/upload-fatture-passive-modal/upload-fatture-passive-modal.ts